import React, { useEffect, useLayoutEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { CHART_MAX_VALUES } from 'constant/variables';

am4core.useTheme(am4themes_animated);

export default function OutletProductChart(props) {
  const [viewData, setViewData] = useState([]);
  const { outletper } = props;
  console.log("OutletProductChart Render", outletper, props.region);
  useEffect(() => {
    
    if (outletper) {
      if (outletper.length === 0) {
        const viewDetail = [];
        const details = {
          category: "Not Available",
          hbb: 0,
          hayyak: 0,
          baqati: 0,
          upgrade: 0,
          achievement: 0,
        };
        viewDetail.push(details);
        setViewData(viewDetail);
      } else {
        const clinic = outletper;
        const viewDetail = [];
        let count = 0;
        console.log("OutletProductChart useEffect called", props.region, clinic)
        for (let index = 0; index < clinic.length; index++) {
          if((count + 1) > CHART_MAX_VALUES) {
            break;
          }
          console.log("OutletProductChart for loop", {index, item: clinic[index], dondition: props.region !== clinic[index].Region})

          if(props.region && props.region !== clinic[index].Region) {

          }else {
            console.log("OutletProductChart for Loop", clinic[index].Region, props.region);
            const details = {
              category: clinic[index].OutletName,
              hbb: clinic[index].HBBSales,
              hayyak: clinic[index].HayyakSales,
              baqati: clinic[index].BaqatiSales,
              upgrade: clinic[index].UpgradeSales,
              achievement: parseInt(clinic[index].TotalAchievedPercentage),
            };
            count++;
            viewDetail.push(details);
          }
        }
        console.log("OutletProductChart viewDetail", viewDetail)
        setViewData(viewDetail);
      }
    }
  }, [outletper, props.region]);

  const gotoEmployeeChart = (ev) => {
    const columnData = ev.target._dataItem?._dataContext || {};
    props.onSelect(columnData.category);
    document.getElementById('employeeTargetId').scrollIntoView({
        behavior: 'smooth'
      })
}


  useLayoutEffect(() => {
    // const chart = am4core.create('outletProductChart', am4charts.XYChart);
    var chart = am4core.create('outletProductChart', am4charts.XYChart)
    chart.scrollbarX = new am4core.Scrollbar();
    chart.scrollbarY = new am4core.Scrollbar();
    chart.colors.step = 2;

    chart.legend = new am4charts.Legend()
    chart.legend.position = 'top'
    chart.legend.paddingBottom = 20
    chart.legend.labels.template.maxWidth = 125

    var xAxis = chart.xAxes.push(new am4charts.CategoryAxis())
    xAxis.dataFields.category = 'category'
    xAxis.renderer.cellStartLocation = 0.1
    xAxis.renderer.cellEndLocation = 0.9
    xAxis.renderer.grid.template.location = 0;

    xAxis.renderer.minGridDistance = 60;
    // xAxis.tooltip.disabled = true;

    xAxis.renderer.labels.template.events.on("hit", gotoEmployeeChart);

    var yAxis = chart.yAxes.push(new am4charts.ValueAxis());
    yAxis.min = 0;
    yAxis.cursorTooltipEnabled = true;

    let paretoValueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    paretoValueAxis.renderer.opposite = true;
    paretoValueAxis.min = 0;
    // paretoValueAxis.max = 100;
    paretoValueAxis.strictMinMax = true;
    paretoValueAxis.renderer.grid.template.disabled = true;
    paretoValueAxis.numberFormatter = new am4core.NumberFormatter();
    paretoValueAxis.numberFormatter.numberFormat = "#'%'";
    paretoValueAxis.cursorTooltipEnabled = false;

    let paretoSeries = chart.series.push(new am4charts.LineSeries());
    paretoSeries.dataFields.valueY = "achievement";
    paretoSeries.dataFields.categoryX = "category";
    paretoSeries.yAxis = paretoValueAxis;
    paretoSeries.tooltipText = "Achievement: ";
    paretoSeries.bullets.push(new am4charts.CircleBullet());
    paretoSeries.strokeWidth = 2;
    paretoSeries.stroke = new am4core.InterfaceColorSet().getFor(
      "alternativeBackground"
    );
    paretoSeries.strokeOpacity = 0.5;

    function createSeries(value, name) {
      var series = chart.series.push(new am4charts.ColumnSeries())
      series.dataFields.valueY = value
      series.dataFields.categoryX = 'category'
      series.name = name
      series.columns.template.width = am4core.percent(100);
      // series.tooltipText = "[{category}: bold]{valueX}[/]";
      series.events.on("hidden", arrangeColumns);
      series.events.on("shown", arrangeColumns);

      var bullet = series.bullets.push(new am4charts.LabelBullet())
      bullet.interactionsEnabled = false
      bullet.dy = 30;
      bullet.label.text = '{valueX}'
      bullet.label.fill = am4core.color('#ffffff')

      series.columns.template.column.cornerRadiusTopLeft = 10;
      series.columns.template.column.cornerRadiusTopRight = 10;
      series.columns.template.column.fillOpacity = 0.8;
      // series.tooltipText = "[{categoryX}: bold]{valueY}[/]";
      series.columns.template.strokeWidth = 0;

      series.columns.template.tooltipText = "{name}: {valueY}";

      // on hover, make corner radiuses bigger
      let hoverState = series.columns.template.column.states.create("hover");
      hoverState.properties.cornerRadiusTopLeft = 0;
      hoverState.properties.cornerRadiusTopRight = 0;
      hoverState.properties.fillOpacity = 1;

      return series;
    }

    chart.data = viewData

      // Modify chart's colors
      chart.colors.list = [
        am4core.color("#0063a4"),
        am4core.color("#f89d21").lighten(0.5),
        am4core.color("#f89d21"),
        am4core.color("#0063a4").lighten(0.5),
      ];

    createSeries('hbb', 'HBB');
    createSeries('hayyak', 'Hayyak');
    createSeries('baqati', 'Baqati');
    createSeries('upgrade', 'Upgrade');

    function arrangeColumns() {

      var series = chart.series.getIndex(0);

      var w = 1 - xAxis.renderer.cellStartLocation - (1 - xAxis.renderer.cellEndLocation);
      if (series.dataItems.length > 1) {
        var x0 = xAxis.getX(series.dataItems.getIndex(0), "categoryX");
        var x1 = xAxis.getX(series.dataItems.getIndex(1), "categoryX");
        var delta = ((x1 - x0) / chart.series.length) * w;
        if (am4core.isNumber(delta)) {
          var middle = chart.series.length / 2;

          var newIndex = 0;
          chart.series.each(function (series) {
            if (!series.isHidden && !series.isHiding) {
              series.dummyData = newIndex;
              newIndex++;
            }
            else {
              series.dummyData = chart.series.indexOf(series);
            }
          })
          var visibleCount = newIndex;
          var newMiddle = visibleCount / 2;

          chart.series.each(function (series) {
            var trueIndex = chart.series.indexOf(series);
            var newIndex = series.dummyData;

            var dx = (newIndex - trueIndex + middle - newMiddle) * delta

            series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
            series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
          })
        }
      }
    }


    // chart.current = chart;

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return <div id="outletProductChart" style={{ width: '100%', height: '500px', direction: "ltr" }} />;
}
